module.exports = __webpack_public_path__ + "static/img/commitment-1_light.3b96ce1a.png";